/**
 * in this file you can define permissions
 * field for ap user per resolution type status.
 */

import { ClaimFormField } from '../types';

export function isEditableApUser(field: string) {
  return !FIELDS_APUSER_READONLY.includes(field as ClaimFormField);
}

export const FIELDS_APUSER_READONLY: ClaimFormField[] = [
  //Matrix fields
  'original',
  'current',
  'proposed',
];
